export default __webpack_public_path__ + "static/media/sample-video.76d45447.mp4";